<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="buy-product-history">
      <Title :jpn="t('履歴')" />
      <HistoryHeader />
      <HistoryTable
        v-if="dispHistoryList && dispHistoryList.length > 0"
        class="history-table"
        :historyList="dispHistoryList"
        :headerNameList="headerNameList"
        :dispKeyList="dispKeyList"
        :headerWidthList="headerWidthList"
        :isHistory="true"
        @handleClick="handleClick"
      />
      <div
        v-if="!(dispHistoryList && dispHistoryList.length > 0)"
        class="no-history"
      >
        <span>{{ t('購入履歴がありません') }}</span>
      </div>
      <!-- <BoxPager
        v-if="dispHistoryList &&
          dispHistoryList.length > 0 &&
          marketHistoryList &&
          marketHistoryList.page.pages.length > 0
        "
        class="box-pager"
        :totalPageCount="marketHistoryList.page.all_page"
        :currentPageCount="marketHistoryList.page.page"
        :dispBoxCount="marketHistoryList.page.pages.length"
        :pages="marketHistoryList.page.pages"
        @handleSquareBtnClick="changeCurrentPageCount"
      /> -->
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  separateCharacterNumber,
} from '@/common/util/format';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import HistoryTable from '@/components/organisms/HistoryTable02.vue';
// import BoxPager from '@/components/organisms/BoxPager.vue';
import Title from '@/components/molecules/Title02.vue';
import HistoryHeader from '@/components/molecules/HistoryHeader.vue';
import t from '@/plugins/i18n';

export default {
  name: 'BuyMarketHistory',
  mixins: [t],

  components: {
    BaseTemplate,
    HistoryTable,
    // BoxPager,
    Title,
    HistoryHeader,
  },

  data: () => ({
    headerNameList: [],
    dispKeyList: [
      'buyDate',
      'shippingNumber',
      'sendState',
      'totalAmount',
    ],
    headerWidthList: ['20%', '40%', '20%', '20%'],
  }),

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      marketHistoryList: 'market/resultMarketPurchaseList',
      selectedMode: 'packHistory/selectedMode',
      selectedMarketId: 'market/selectedMarketId',
    }),
    dispHistoryList() {
      if (this.marketHistoryList) {
        // Objectの中から数値キーだけ抽出して配列化
        const items = Object.keys(this.marketHistoryList)
          .filter((key) => !Number.isNaN(Number(key)))
          .map((key) => this.marketHistoryList[key]);
        if (items.length > 0) {
          const dispHistoryList = items.reduce((acc, cur) => {
            const { id } = cur;
            const buyDate = cur.created.split(' ')[0].replace(/-/g, '/').slice(2);
            const shippingNumber = cur.shipping_number ?? '-';
            const sendState = cur.send_state;
            const totalAmount = cur.total_amount; // ← ここpointじゃなくtotal_amountに直す
            acc.push({
              id,
              buyDate,
              shippingNumber,
              sendState,
              totalAmount: `&yen;${separateCharacterNumber(totalAmount)}`,
            });
            return acc;
          }, []);

          return dispHistoryList;
        }
      }
      return [];
    },

  },

  created() {
    this.$store.dispatch('market/purchase_list');
    this.headerNameList = [
      this.t('日付'),
      this.t('追跡番号'),
      this.t('発送状況'),
      this.t('金額'),
    ];
  },

  methods: {
    goToBuyMarketHistoryDetail(id) {
      (async () => {
        this.$router.push({
          path: '/market-history-detail',
          query: { id },
        });
      })();
    },
    handleClick(dispKey, item) {
      if (dispKey === 'totalAmount') {
        this.goToBuyMarketHistoryDetail(item.id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$pagerWidth: 100%;

.buy-product-history{
  position: relative;
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 90px;
  margin: 0px auto;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  @media screen and (min-width:767px){
    max-width: 580px;
  }
  @media screen and (min-width:1023px){
    max-width: 1000px;
  }
  // .box-pager{
  //   bottom: 30px;
  //   width: $pagerWidth;
  //   height: 30px;
  //   margin: 0px auto;
  // }
  .no-history{
    margin-top: 20px;
    font-family: $notoSans;
    font-size: 14px;
    line-height: 2.25;
    color: $white;
    text-align: center;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .buy-product-history{
    padding: 30px 0 90px;
    .history-table{
      .history-table-body {
        font-size: 12px;
      }
    }
  }
}
</style>
